import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'

import DigitalRenderer from '.'
import DigitalPage from './screens/DigitalPage'

const Routes = ({ history }) => (
  <ConnectedRouter history={history}>
    <DigitalRenderer>
      <Switch>
        <Route exact path="/" component={DigitalPage} />
      </Switch>
    </DigitalRenderer>
  </ConnectedRouter>
)

Routes.propTypes = {
  history: PropTypes.object.isRequired,
}

export default Routes
